package com.trevorwiebe.timesheet.invoicing.presentation

import kotlinx.datetime.LocalDate

sealed class InvoicingEvent {
    data class OnSelectTab(val tab: InvoiceListTab) : InvoicingEvent()

    data object OnNewInvoiceClick : InvoicingEvent()
    data object OnDismissNewInvoice : InvoicingEvent()
    data class OnSelectCustomer(val customerId: String) : InvoicingEvent()
    data object OnStartDateClick : InvoicingEvent()
    data object OnEndDateClick : InvoicingEvent()
    data class OnStartDateSelected(val date: LocalDate?) : InvoicingEvent()
    data class OnEndDateSelected(val date: LocalDate) : InvoicingEvent()
    data object OnDismissDatePickers : InvoicingEvent()
    data class OnToggleLoad(val loadId: String) : InvoicingEvent()
    data object OnSelectAllLoads : InvoicingEvent()
    data object OnClearLoadSelection : InvoicingEvent()
    data object OnCreateInvoice : InvoicingEvent()

    data class OnInvoiceClick(val invoiceId: String) : InvoicingEvent()
    data object OnCloseInvoice : InvoicingEvent()
    data object OnRequestDelete : InvoicingEvent()
    data object OnDismissDelete : InvoicingEvent()
    data object OnConfirmDelete : InvoicingEvent()

    data object OnRequestUpdateInvoice : InvoicingEvent()
    data object OnDismissUpdateInvoice : InvoicingEvent()
    data object OnConfirmUpdateInvoice : InvoicingEvent()

    data object OnRequestMarkSent : InvoicingEvent()
    data object OnDismissMarkSent : InvoicingEvent()
    data object OnConfirmMarkSent : InvoicingEvent()

    /** Opens Receive Payment, preset to [customerId] when started from an invoice. */
    data class OnReceivePaymentClick(val customerId: String? = null) : InvoicingEvent()
    data object OnDismissReceivePayment : InvoicingEvent()
    data class OnPaymentCustomerSelected(val customerId: String) : InvoicingEvent()
    data class OnPaymentAmountChanged(val text: String) : InvoicingEvent()
    data object OnPaymentDateClick : InvoicingEvent()
    data class OnPaymentDateSelected(val date: LocalDate) : InvoicingEvent()
    data object OnDismissPaymentDatePicker : InvoicingEvent()
    data class OnAllocationChanged(val invoiceId: String, val text: String) : InvoicingEvent()
    data object OnSavePayment : InvoicingEvent()

    data class OnRequestDeletePayment(val paymentId: String) : InvoicingEvent()
    data object OnDismissDeletePayment : InvoicingEvent()
    data object OnConfirmDeletePayment : InvoicingEvent()

    data object OnViewPdfClick : InvoicingEvent()
    data object OnPdfOpened : InvoicingEvent()

    data object OnSendClick : InvoicingEvent()
    data class OnSendRecipientChanged(val text: String) : InvoicingEvent()
    data class OnToggleSendDocument(val url: String) : InvoicingEvent()
    data class OnOpenDocument(val url: String) : InvoicingEvent()
    data object OnCloseDocument : InvoicingEvent()
    data object OnDismissSend : InvoicingEvent()
    data object OnConfirmSend : InvoicingEvent()

    data object OnInfoShown : InvoicingEvent()
    data object OnErrorShown : InvoicingEvent()
}
